import { AxiosResponse } from "axios";
import { message } from "ant-design-vue";
import { HttpService } from "@/core";
import { ResponseResp } from "@/core/interface";
import {Ref,ref} from "vue"
import { SignReq, SignResp, StsAccount } from "./file-upload.interface";
//公有权限
const PUBLIC_URL='/v1/oss/sign';
//私有权限
const PRIVATE_URL='/v1/oss/signPartnerOne';

interface IUrls{
  url:string;
  key:string;
}
export class FileUploadService {
  /**
   * 生成安全的文件名，避免中文和特殊字符导致URL无法访问
   * 保留文件扩展名，文件名替换为时间戳+随机串
   */
  static getSafeFileName(fileName: string): string {
    const extIndex = fileName.lastIndexOf(".");
    const ext = extIndex > -1 ? fileName.substring(extIndex) : "";
    return `${Date.now()}_${Math.random().toString(36).substring(2, 10)}${ext}`;
  }

  /**
   * 对URL中的路径部分进行编码，处理中文和特殊字符
   */
  static encodeOSSUrl(url: string): string {
    if (!url) return url;
    try {
      // 检查URL中是否包含非ASCII字符（中文等）
      if (!/[\u0080-\uffff]/.test(url)) return url;
      const parsed = new URL(url);
      // 先decode再encode，避免重复编码
      const decodedPath = decodeURI(parsed.pathname);
      const encodedPath = encodeURI(decodedPath);
      return `${parsed.origin}${encodedPath}${parsed.search}`;
    } catch {
      return url;
    }
  }
  /**
   * 获取上传签名
   */
  static async fetchSign(params: SignReq): Promise<any> {
    let sign;
    try {
      const r: AxiosResponse<ResponseResp<any>> = await HttpService.axios({
        method: "GET",
        url: params.path,
        params,
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
      } else {
        sign = res.data;
      }
    } catch (e: any) {
      message.error(e.message);
    }
    return sign;
  }
  /**
   * 获取文件路径
   */
  static async fileUrlSign(host, fd): Promise<any> {
    let url;
    try {
      const r: AxiosResponse<ResponseResp<any>> = await HttpService.axios({
        method: "POST",
        // url: process.env.VUE_APP_BASE_API + host,
        url:host,
        data: fd,
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
      } else {
        url = res.data.url;
      }
    } catch (e: any) {
      message.error(e.message);
    }
    return url;
  }

  static async generateSignUrl(keys){
    let url;
    try {
      const r: AxiosResponse<ResponseResp<SignResp>> = await HttpService.axios({
        method: "post",
        url: "/v1/oss/get",
        data:keys,
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
      } else {
        url = res.data;
      }
    } catch (e: any) {
      message.error(e.message);
    }
    return url;
  }

  static async uploadFileToOss(file,path,loading=ref(false)){
    let url = "";
    const signReq = new SignReq();
    // 使用安全文件名，避免中文和特殊字符导致后续URL无法访问
    const safeFileName = FileUploadService.getSafeFileName(file.name);
    signReq.merge({ dir: "cpms", fileName: safeFileName, path });
    const sign = await FileUploadService.fetchSign(signReq);

    if (!sign) {
      return url;
    }
    try {
      const fd = new FormData();
      fd.append("key", sign.key);
      fd.append("policy", sign.policy);
      fd.append("OSSAccessKeyId", sign.OSSAccessKeyId);
      fd.append("success_action_status", "200");
      fd.append("signature", sign.signature);
      fd.append("file", file, safeFileName);
      if(loading){
        (loading as Ref).value=true;
      }
      // await HttpService.axios({
      //   method: "POST",
      //   url: process.env.VUE_APP_BASE_API + sign.host,
      //   data: fd,
      // });

      url = await FileUploadService.fileUrlSign(sign.host, fd);
      // 对返回的URL进行编码，处理可能残留的中文和特殊字符
      url = FileUploadService.encodeOSSUrl(url);

      if(loading){
        (loading as Ref).value=false;
      }
      // url = `${sign.host}/${sign.key}`;
    } catch (e: any) {
      if(loading){
        (loading as Ref).value=false;
      }
      message.error("附件上传失败");
    }
    // if(path === PRIVATE_URL){
    //   let key = sign.key
    //   let urls = await FileUploadService.generateSignUrl([key])
    //   return {url:urls.expirationUrl[key],key};
    // }else if(path === PUBLIC_URL){
    //   return url;
    // }
    return url;
  }
  //上传到私有权限oss
  static async uploadToPrivateOss(file):Promise<IUrls>{
    //@ts-ignore
    return FileUploadService.uploadFileToOss(file,PRIVATE_URL);
  }
  /**
   * 上传文件到公有权限阿里云OSS
   */
  static async uploadToOss(file,loading=ref(false)):Promise<string> {
    //@ts-ignore
    return FileUploadService.uploadFileToOss(file,PUBLIC_URL,loading);
  }

  static fetchSts(){
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/v1/oss/sts/account",
      });
    return HttpService.useRequest<StsAccount>(api);
  }
}
